<template>
    <div v-if="load" class="wrapper">
        <div class="anew" @click="( $jump('/report'))"></div>
        <div class="title">我的鹭岛专属名片</div>
        <div class="callingCardBox">
            <div class="text">#2024年接好运#</div>
            <div class="box">
                <div class="left">
                    <div class="information">
                        <div class="nameText">姓名/name</div>
                        <div class="name">{{ dataModel.name }}</div>
                        <div class="timeText" v-show="time">注册时间/time</div>
                        <div class="name" v-show="time" style="top:0">{{ time }}</div>
                        <div class=""></div>
                    </div>
                    <div class="labels">
                        <div class="labelsText" :class="dataModel.manualTag&&dataModel.manualTag.length==5?'center':''">{{ dataModel.manualTag }}</div>
                        <div class="proportion">全城仅有{{dataModel.percent}}%用户获得</div>
                    </div>
                </div>
                <div class="right">
                    <div class="rightText">{{ rightText }}</div>
                    <div class="imgBox" v-if="imgModel.url">
                        <img :src="imgModel.url" alt="" >
                    </div>
                    <div class="re" @click="($jump('/imageCustomization'))">
                        <div class="refresh"></div>
                        <div class="reText">重绘形象</div>
                    </div>
                </div>
            </div>
            <div class="signature">{{ dataModel.goldenSentence }}</div>
        </div>
        <div class="rewardsBox">
            <div class="rewardsTitle">分享赢好礼</div>
            <div class="prizesList">
                <div :class="item.type==1?'prizesBox1':'prizesBox2'" v-for="(item,index) in prizeList" :key="index">
                    <div class="prizes">
                        <div class="tag">{{item.type==1?'必得':'稀有'}}</div>
                        <div class="prizesImg">
                            <img :src="'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/prizes' + item.type + '.png'" alt="">
                        </div>
                    </div>
                    <div class="prizesName">{{ item.name }}</div>
                </div>
                <!-- <div class="prizesBox1">
                    <div class="prizes">
                        <div class="tag">必得</div>
                        <div class="prizesImg">
                            <img src="@/assets/images/prizes1.png" alt="">
                        </div>
                    </div>
                    <div class="prizesName">移动5元话费券</div>
                </div>
                <div class="prizesBox2">
                    <div class="prizes">
                        <div class="tag">稀有</div>
                        <div class="prizesImg">
                            <img src="@/assets/images/prizes2.png" alt="">
                        </div>
                    </div>
                    <div class="prizesName">见福爆品券</div>
                </div>
                <div class="prizesBox2">
                    <div class="prizes">
                        <div class="tag">稀有</div>
                        <div class="prizesImg">
                            <img src="@/assets/images/prizes2.png" alt="">
                        </div>
                    </div>
                    <div class="prizesName">见福爆品券</div>
                </div> -->
            </div>
        </div>
        <div class="luckyDraw-bt" v-show="dataModel.isPrizeDraw == 0" @click="luckyDraw"></div>
        <div class="viewPrizes" v-show="dataModel.isPrizeDraw == 1" @click="jump"></div>
        <div class="sharing-bt" @click="sharing"></div>
        <packPop ref="packPop" :prizeImg="prizeImg"  :drawList="drawList" @details="details" />
        <sharePop ref="sharePop" @details="details" :codeUrl="codeUrl" :dataModel="dataModel" :time="time" :imgModel="imgModel" />
    </div>
</template>

<script>
import packPop from './packPop.vue'
import sharePop from './sharePop.vue'
import { details,getPrizeList,prizeDraw,editShare } from '@/api'

export default {
    components: {
        packPop,
        sharePop
    },
    props: {},
    data() {
        return {
            load: false,
            codeUrl:'',
            time:'',
            prizeList:[
            {
                type:1,
                name:'移动专属i厦门周年礼包',
            },
            {
                type:2,
                name:'见福爆品组合券',
            },{
                type:2,
                name:'见福代金券',
            },
            {
                type:1,
                name:'10元养老体验金',
            }
            ],
            drawList:[],
            prizeImg:[{
                id:1,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/prizes3.png',
            },{
                id:2,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/nh.png',
            },{
                id:3,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },{
                id:4,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:5,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:6,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:7,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:8,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:9,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:10,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:11,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:12,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:13,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:14,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            },
            {
                id:15,
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/jf.png',
            }],
            text:'稳重\n肖年家',
            rightText:'i厦门2023年度报告\n/年度形象',
            dataModel:{},
            sexList:[{
                url:require('@/assets/images/girl1.png'),
                sex:2,
                id:1
            },{
                url:require('@/assets/images/male1.png'),
                sex:1,
                id:2
            },{
                url:require('@/assets/images/girl2.png'),
                sex:2,
                id:3
            },{
                url:require('@/assets/images/male2.png'),
                sex:1,
                id:4
            },{
                url:require('@/assets/images/girl3.png'),
                sex:2,
                id:5
            },{
                url:require('@/assets/images/male3.png'),
                sex:1,
                id:6
            },],

        }
    },
    watch: {},
    computed: {
        imgModel(){
            let data = this.sexList.filter(item=>{
                return item.id == this.dataModel.roleNumber
            })
            return data[0]
        }
    },
    methods: {
        editShare(){
            editShare().then(res=>{
                console.log('成功')
                
                this.details()

            })
        },

        jump(){
            this.$jump('/prize')

        },
        sharing(){
            let urerInfo = JSON.parse(localStorage.getItem('userInfo'))
            if(this.dataModel.isShare == 0){
                this.editShare()
            }
            aplus_queue.push({
                 action: 'aplus.record',
                 arguments: ['share', 'CLK', {
                    userId:urerInfo.id,

                 }]
             })
            this.$refs.sharePop.show = true
            this.$refs.sharePop.share = true


        },
        luckyDraw(){
            let date = +new Date()
            let staTime = Date.parse('2024/01/01 00:00:00') 
            if(date>staTime){
                this.$toast('抽奖已结束')
                return

            }
            let urerInfo = JSON.parse(localStorage.getItem('userInfo'))
            if(this.dataModel.isShare == 0){
                //先分享
                aplus_queue.push({
                     action: 'aplus.record',
                     arguments: ['share', 'CLK', {
                        userId:urerInfo.id,

                     }]
                 })
                this.$refs.sharePop.show = true
            }else{
                //抽奖
                this.prizeDraw()
            }

        },
        prizeDraw(){
            // this.drawList = []
            // prizeDraw().then(res=>{
            //     console.log(res)
            //     let data = res.data.data
            //     data.forEach(ele=>{
            //         this.prizeImg.forEach(item=>{
            //             if(ele.prizeId == item.id){
            //                 this.drawList.push({
            //                     ...ele,
            //                     link:ele.url,
            //                     url:item.url
            //                 })
            //             }
                        
            //         })
                    
            //     })
            //     this.details()
                
            // })
            this.$refs.packPop.show = true
        },
        details(){
            this.$toast.loading({
                message: '数据载入中',
                forbidClick: true,
                duration: 0,
            })
            details().then(res=>{
                this.dataModel = res.data.data
                if(this.dataModel.registDate){
                    this.slice()
                }
                this.load = true
            }).finally(() => {
                this.$toast.clear()
            });
        },
        slice(data,key){
            let years = this.dataModel.registDate.substring(0,4)
            let month = this.dataModel.registDate.substring(4,6) 
            let day = this.dataModel.registDate.substring(6,8) 
            this.time = years + '年' + month + '月' + day + '日'

        },
        getPrizeList(){
            getPrizeList().then(res=>{
                this.prizeList = res.data.data


            })
        }
    },
    created() { 
        this.codeUrl = location.origin + location.pathname + "#/loading?channel=fx"
        this.details()
        // this.getPrizeList()
    },
    mounted() { }
}
</script>
<style scoped lang="scss">
.wrapper {
    width: 100vw;
    min-height: 100vh;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/imageCustomizationBg.png);
    background-position: top;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
}
.anew{
    width: 2.91rem;
    height: .59rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/anew.png);
    margin-top: .58rem;
}
.title{
    width: 100%;
    height: .67rem;
    line-height: .67rem;
    text-align: center;
    color: #fff;
    font-family: DingTalkJinBuTi;
    font-size: .54rem;
    margin-top: .16rem;
}
.luckyDraw-bt{
    width: 4.12rem;
    height: 1.4rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/luckyDraw-bt.png);
    margin-top: .2rem;
}
.viewPrizes{
    width: 4.12rem;
    height: 1.4rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/viewPrizes.png);
    margin-top: .2rem;
}
.sharing-bt{
    width: 4.12rem;
    height: 1.4rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/sharing-bt.png);
    margin-top: -.2rem;
}
.rewardsBox{
    width: 7.7rem;
    height: 3.3rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/rewardsBox.png);
    display: flex;
    flex-direction: column;
    align-items: center;
    .rewardsTitle{
        width: 6.2rem;
        height: .37rem;
        line-height: .37rem;
        font-size: .32rem;
        font-family: DingTalkJinBuTi;
        color: #194769;
        margin-top: .65rem;
    }
    .prizesList{
        width: 6.4rem;
        height: 2rem;
        margin-top: .2rem;
        display: flex;
        align-items: center;
        overflow-x: scroll;
        overflow-y: hidden;

        .prizesName{
            width: 100%;
            height: .35rem;
            line-height: .35rem;
            color: #909090;
            text-align: center;
            font-size: .25rem;
            margin-top: .16rem;
            font-family: SourceHanSansCNMedium;

        }

        .prizesBox2{
            min-width: 2.5rem;
            max-height: 2rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            

            .prizes{
                width: 2.03rem;
                min-height: 1.26rem;
                background-color: #FDF2EF;
                border-radius: .35rem;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                .tag{
                    width: .58rem;
                    height: .29rem;
                    line-height: .29rem;
                    background: linear-gradient(180deg, #FF6A6A 0%, #F4B654 100%);
                    text-align: center;
                    font-size: .21rem;
                    font-family: SourceHanSansCNMedium;
                    border-radius: .25rem;
                    color: #fff;
                    position: absolute;
                    right: -.12rem;
                    top: -.06rem;
                }
                .prizesImg{
                    width: 1.82rem;
                    height: 1rem;

                    img{
                        max-width: 100%;
                        height: auto;

                    }

                }
            }

        }

        .prizesBox1{
            min-width: 2.5rem;
            max-height: 2rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            white-space: nowrap;

            .prizes{
                width: 2.03rem;
                height: 1.26rem;
                background-color:  #F5F6F9;
                border-radius: .35rem;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                .tag{
                    width: .58rem;
                    height: .29rem;
                    line-height: .29rem;
                    background: linear-gradient(93deg, #BBDBEF 0%, #7EA9FC 100%);
                    text-align: center;
                    font-size: .21rem;
                    font-family: SourceHanSansCNMedium;
                    border-radius: .25rem;
                    color: #fff;
                    position: absolute;
                    right: -.12rem;
                    top: -.06rem;
                }

                .prizesImg{
                    width: 1.58rem;
                    height: 1.58rem;

                    img{
                        max-width: 100%;
                        height: auto;

                    }

                }
                .prizesImg2{
                    width: 1rem;
                    height: 1rem;

                    img{
                        max-width: 100%;
                        height: auto;

                    }

                }

            }
        }
    }
    
}
.callingCardBox{
    width: 7.7rem;
    height: 7.7rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/callingCardBox.png);
    margin-top: .53rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .text{
        position: absolute;
        width: 6.2rem;
        height: .32rem;
        line-height: .32rem;
        text-align: right;
        font-size: .32rem;
        color: #fff;
        font-family: DingTalkJinBuTi;
        top: .3rem;

    }
    .signature{
        width: 6.27rem;
        height: .63rem;
        line-height: .63rem;
        color: #194769;
        font-size: .28rem;
    }
    .box{
        width: 6.26rem;
        height: 5.77rem;
        border-bottom: .02rem solid #A9D9FD;
        display: flex;
        margin-top: 1.1rem;
    }
    .right{
        width: 3.12rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .re{
            width: 1.42rem;
            height: .37rem;
            border-radius: .2rem;
            background-color: rgba(0,0,0,.7);
            position: absolute;
            bottom: .1rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .refresh{
                width: .33rem;
                height: .33rem;
                background-size: 100% auto;
                background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/refresh.png);
            }
            .reText{
                height: .33rem;
                line-height: .33rem;
                font-size: .21rem;
                margin-left: .04rem;
                color: #fff;
                font-family: SourceHanSansCNMedium;
            }
        }
        .rightText{
            width: 100%;
            text-align: right;
            white-space: pre-line;
            font-size: .21rem;
            font-family: SourceHanSansCNMedium;
        }
        .imgBox{
            width: 100%;
            height: 4.7rem;
            margin-top: .2rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img{
                width: auto;
                max-height: 100%;
            }
        }
    }
    .left{
        width: 3.14rem;
        height: 5.77rem;
        border-right: .02rem solid #A9D9FD;
        .labels{
            width: 100%;
            height: 3.94rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .center{
                text-align: center;
            }

            .labelsText{
                width: 100%;
                font-size: .71rem;
                color: #264666;
                font-family: DingTalkJinBuTi;
                white-space: pre-line;

            }
            .proportion{
                width: 3.01rem;
                height: .51rem;
                line-height: .51rem;
                border-radius: .3rem;
                background-color: #80c7fd;
                font-size: .28rem;
                text-align: center;
                color: #fff;
                font-family: DingTalkJinBuTi;
                margin-top: .21rem;
            }
        }
        .information{
            width: 3.14rem;
            height: 1.82rem;
            border-bottom: .02rem solid #A9D9FD;
            box-sizing: border-box;
            .nameText{
                width: 100%;
                height: .33rem;
                line-height: .33rem;
                font-size: .28rem;
                color: #85B4EA;
                font-family: DingTalkJinBuTi;
                // margin-top: -.2rem;
                position: relative;
                top: -.2rem;
            }
            .name{
                width: 100%;
                height: .49rem;
                line-height: .49rem;
                font-size: .35rem;
                color: #194769;
                font-family: SourceHanSansCNMedium;
                position: relative;
                top: -.2rem;
            }
            .timeText{
                width: 100%;
                height: .33rem;
                line-height: .33rem;
                font-size: .28rem;
                color: #85B4EA;
                font-family: DingTalkJinBuTi;
                margin-top: .01rem;
                
            }
        }
    }

}
</style>